import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { max, compose, head, prop, groupWith, sortWith, ascend, descend, path } from 'ramda';

import { routes } from '../../../../routes';

import Card from '../../../../components/Card';

const propTypes = {
  certifications: PropTypes.array,
  renewal: PropTypes.object,
};

const CertificationsCard = ({ certifications, renewal }) => {
  const grouped = compose(
    groupWith((a, b) => a.certificationId == b.certificationId),
    sortWith([descend(prop('certificationId')), descend(prop('reportingPeriodId')), ascend(prop('status'))]),
  )(certifications);

  // TODO: Make less hardcoded
  const isAfccCertification = path(['certification', 'certificationId'], renewal) == 4;

  return (
    <Card certification className="mb-4">
      <Card.Header certification>
        Certifications
        <h4 className="subheader">
          <strong>Status: </strong>
          {renewal.year == new Date().getFullYear() && renewal.payment ? (
            <span>
              {isAfccCertification ? (
                <a href="https://financialfitness.ca" target="_blank">
                  Pay {renewal.year} fees
                </a>
              ) : (
                <Link to={routes.certificationsAndTraining.certifications.pay}>Pay {renewal.year} fees</Link>
              )}
            </span>
          ) : (
            <span>{max(0, renewal.credits)} CEUs remaining</span>
          )}
        </h4>
      </Card.Header>
      <Card.Body>
        <table className="table">
          <thead>
            <tr>
              <th>Certification</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {grouped.map((userCertifications) => {
              const userCertification = head(userCertifications);

              return (
                <tr key={userCertification.id}>
                  <td>{userCertification.name}</td>
                  <td>{userCertification.status}</td>
                  <td className="text-right">
                    <Link
                      className="btn btn-sm btn-outline-primary"
                      to={routes.certificationsAndTraining.certifications.viewBuilder(
                        userCertification.certificationId,
                      )}
                    >
                      View
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Card.Body>
    </Card>
  );
};

CertificationsCard.propTypes = propTypes;

export default CertificationsCard;
